import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DetailsService } from './details.service';
import { Transaction } from '../../model/transaction.model';
import { map } from 'rxjs/operators';
import { fade } from '../shared/animations';
import { CIKService } from '../cik/cik.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  animations: [fade]
})

export class DetailsComponent implements OnInit, OnDestroy {
  detailsSubscription: Subscription;
  details: Transaction;
  filingLink: string;
  ready;
  constructor(
    private detailsService: DetailsService,
    private cikService: CIKService
  ) { }

  ngOnInit(): void {
    this.detailsSubscription = this.detailsService.detailsSubject$
      .pipe(map(res => {
        this.filingLink = `<a href=${res.linkHtm} target="_blank">View Filing</a>`;
        return res;
      })).subscribe(
        (res: Transaction) => {
          // console.log('cik: ', this.cikService.getCurrentCIK());
          if (res.CIK === this.cikService.getCurrentCIK()) {
            this.details = res;
            setTimeout(() => {
              this.ready = true;
            }, 100);
          } else {
            this.details = null;
          }
        }
      );
  }

  ngOnDestroy() {
    if (this.detailsSubscription) {
      this.detailsSubscription.unsubscribe();
    }
  }

}
